import { Outlet, useLocation } from "react-router-dom";
import MFooter from "./footer/MFooter";
import AHeader from "./header/AHeader";
import AMHeader from "./header/AMHeader";
import MHeader from "./header/MHeader";
import RightQuick from "./quick/RightQuick";
import BottomBar from "./quick/BottomBar";

const Layout = () => {
  const { pathname } = useLocation();

  if (pathname.includes("login")) {
    return (
      <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
        <Outlet />
      </div>
    );
  }
  if (pathname.includes("admin")) {
    if (!sessionStorage.getItem("email")) {
      window.location.href = "/admin/login";
      return <></>;
    }
    return (
      <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
        <AMHeader />
        <AHeader />
        <div className="relative w-full h-full max-w-screen-2xl py-32 lg:py-36 px-2 lg:pl-[280px] 2xl:pl-[300px]">
          <Outlet />
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
      <MHeader />
      <div className="relative w-full h-fit mt-14 lg:mt-10 min-h-[50vh] transition-all duration-100">
        <Outlet />
      </div>
      <RightQuick />
      <BottomBar />
      <MFooter />
    </div>
  );
};

export default Layout;
